import IllustrationWrapper from '../../../v3/Illustrration/IllustrationWrapper';
import DeleteSvg from '../../../v3/Illustrration/components/DeleteSvg';
import GlassModal from './GlassModal';
import { Box } from '@mui/material';
import CustomButton from '../Button/CustomButton';

const DeleteModal = ({
    open,
    onClose,
    onConfirm,
    loading,
    illustrationTitle,
    illustrationSubtitle,
    cancelLabel,
    deleteLabel
}) => {
  const handleCancelClick = () => {
    onClose();
  };

  const handleDeleteClick = () => {
    onConfirm();
  };
  return (
    <GlassModal
        open={open}
        onClose={onClose}
        title=""
        scrollable={true}
        maxWidth="500px"
        zIndex={2}
        pt={4}
        showHeader={false}
    >
      <Box sx={{ textAlign: 'center'}}>
          <IllustrationWrapper
            illustration={<DeleteSvg />}
            title={illustrationTitle}
            subtitle={illustrationSubtitle}
          />
      </Box>
      <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center', mt: 2 }}>
          <CustomButton
            variant="outlined"
            color="primary"
            label={cancelLabel || "No"}
            onClick={handleCancelClick}
            sx={{ width: '100%' }}
          />
          <CustomButton
            variant="filled"
            color="primary"
            label={deleteLabel || "Yes"}
            onClick={handleDeleteClick}
            disabled={loading}
            loading={loading}
            sx={{ width: '100%' }}
          />
      </Box>
    </GlassModal>
  );
};

export default DeleteModal;
